<template>
	<v-main>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-btn icon color="primary" @click="$router.push('/')">
						<v-icon >mdi-home</v-icon>
					</v-btn>
					<!-- breadcrumbs -->
					<!-- <v-breadcrumbs :items="breadcrumbs" divider="-">
						<template v-slot:item="{ item }">
							<v-breadcrumbs-item
								:to="item.to"
								:disabled="item.disabled"
								:exact="item.exact"
							>
								{{ $vuetify.lang.t('$vuetify.'+item.text) | capitalize }}
							</v-breadcrumbs-item>
						</template>
					</v-breadcrumbs> -->
				</v-col>

				<v-col cols="12" class="d-flex justify-center">
					<v-card elevation="0" width="600px">
						<v-toolbar class="elevation-0">
							<v-icon class="mr-6">{{ icon }}</v-icon>
							<v-toolbar-title>{{ $vuetify.lang.t('$vuetify.'+title) | capitalize }}</v-toolbar-title>
							<v-spacer></v-spacer>
						</v-toolbar>
						<v-card-text>
							<v-form ref="form">
								<v-row>
									<v-col cols="12">
										<v-text-field
											v-model="item.name"
											:label="$vuetify.lang.t('$vuetify.pib') | capitalize"
											required
											:rules="[rules.required]"
											@keyup.ctrl.90="OnDefault"
										></v-text-field>
									</v-col>                                  
									<v-col cols="12" sm="6" md="6">
										<v-text-field
											v-model="item.email"
											:label="$vuetify.lang.t('$vuetify.email') | capitalize"
											prepend-icon="mdi-email"
											required
											:rules="[rules.required, rules.email]"
											@keyup.ctrl.90="OnDefault"
										></v-text-field>
									</v-col>
									<v-col cols="12" sm="6" md="6">
										<v-text-field 
											v-model="item.phone"
											:label="$vuetify.lang.t('$vuetify.telephone') | capitalize"
											prepend-icon="mdi-phone"
											:rules="[rules.phone]"
											@keyup.ctrl.90="OnDefault"
										></v-text-field>
									</v-col>
									<v-col cols="12" sm="6" md="6">
										<v-text-field 
											v-model="item.password"
											:label="$vuetify.lang.t('$vuetify.password') | capitalize"
											prepend-icon="mdi-lock"
											hint="At least 8 characters"
											type="password"
											min="8"                                            
											required
											:rules="[rules.required]"
											@keyup.ctrl.90="OnDefault"
										></v-text-field>
									</v-col>
									<v-col cols="12" sm="6" md="6">
										<v-text-field 
											v-model="item.confirm"
											:label="$vuetify.lang.t('$vuetify.passwordconfirm') | capitalize"
											prepend-icon="mdi-lock"
											hint="At least 8 characters"
											type="password"
											min="8"
											required
											:rules="[rules.required]"
											@keyup.ctrl.90="OnDefault"
										></v-text-field>
									</v-col>
								</v-row>
							</v-form>

								<!-- <v-alert v-if="alert.text" outlined :type="alert.type" prominent border="left">
									{{alert.text}}
								</v-alert> -->
						</v-card-text>

						<v-card-actions>
							<!-- <v-spacer></v-spacer> -->
							<v-btn large block
								:loading="loading"
								@click.native="OnOk"
								color="success"
								dark
							>
								<v-icon left dark>mdi-check-bold</v-icon>	
								{{ $vuetify.lang.t('$vuetify.ok') }}
							</v-btn>
							<!-- <v-spacer></v-spacer> -->
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-main>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import { mapGetters, mapActions } from 'vuex'
import router from '../router'


export default {
	components: {
		VueRecaptcha
	},
	data: () => ({
		//title: 'signup',
		title: 'donthaveaccount',
		icon: 'mdi-account-plus',
		loading: false,

		breadcrumbs: [
			{ text: 'homepage', disabled: false, to:{name: 'home'}, exact: true},
			{ text: 'signup', disabled: true},
		],

		rules: {
			required: (value) => !!value || 'Required.',
		},

		item: {
			firstname: null
			,middlename: null
			,lastname: null
			,password: null
			,nicname: null
			,company: null
			,email: null
			,phone: null
			,image: null
			,description: null
			,password: null
			,confirm: null
		},

	}),
	
	computed: {
		
	},
	methods: {
		...mapActions('app',[
			'Signup'
		]),

		
		OnDefault () {
			//ctrl+z
			this.item.name        = "Іваненко Іван Іванович"
			this.item.email       = "qwins@i.ua"
			this.item.phone       = "+380971112233"
			this.item.password    = "123"
			this.item.confirm     = "123"
		},  

		OnOk() {
			var that = this;
			//this.alert.text = null;

			if (this.$refs.form.validate()) {
				if(this.password == this.confirm) {
					this.loading = true;
					this.Signup({
						params: this.item,
						success: function(response) {
							that.loading = false;
							router.push('/')
							//that.alert.text = null;
						},
						error: function(response) {
							that.loading = false
							//that.alert.text = response.data;
						},
					});
				} else {
					//this.alert.text = "Пароль та його підтвердження відрізняються між собою."
				}
			}
		},
	},
}
</script>